// The redesigned sound page's behaviour: its own Vite entry with only the x-ui parts it uses, so neither app.js nor
// the library bundle grows. Load it before app.js: it registers on `alpine:init`, which fires when Livewire starts Alpine.
import './alpine/ui-tip';
import './alpine/ui-rows';
import './alpine/ui-undo';
import './alpine/ui-drop';
import { uiSegmented, uiPlayerStore } from './alpine/ui';
import { uiDropdown, uiDialog } from './alpine/ui-controls';
import { uiTopbar } from './alpine/ui-nav';
import { soundPage, spGrowth, spBar } from './alpine/sound-page';
import { uiSwarm } from './alpine/ui-swarm';

const components = { uiSegmented, uiDropdown, uiDialog, uiTopbar, soundPage, spGrowth, spBar, uiSwarm };

document.addEventListener('alpine:init', () => {
    Object.entries(components).forEach(([name, fn]) => window.Alpine.data(name, fn));
    window.Alpine.store('uiPlayer', uiPlayerStore);
});
